import React, { JSX } from 'react';

type VideoProps = {
  videoId?: string;
  videoUrl?: string;
  aditionalClass?: string;
  additionalId?: string;
};

const Video = ({
  videoId,
  videoUrl,
  aditionalClass,
  additionalId,
}: VideoProps): JSX.Element => (
  <>
    {videoUrl && !videoUrl.includes('freshpaint-video.com') ? (
      <video
        muted
        autoPlay
        loop
        className={aditionalClass ? aditionalClass : ''}
      >
        <source
          className="jss-hero-video"
          src={videoUrl + `?t=w400`}
          type="video/mp4"
        ></source>
        <source
          className="jss-hero-video"
          src={videoUrl + `?t=w800`}
          type="video/mp4"
        ></source>
        <source
          className="jss-hero-video"
          src={videoUrl + `?t=w2000`}
          type="video/mp4"
        ></source>
        <video className="jss-hero-video" src={videoUrl + `?t=w800`} />
      </video>
    ) : videoUrl?.includes('freshpaint-video.com') ? (
      <div
        className={aditionalClass ? aditionalClass : ''}
        id={additionalId ? additionalId : ''}
      >
        <iframe
          src={videoUrl}
          title="Freshpaint Video Player"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          allowFullScreen
        ></iframe>
      </div>
    ) : (
      <div
        className={aditionalClass ? aditionalClass : ''}
        id={additionalId ? additionalId : ''}
      >
        <iframe
          src={`https://www.youtube.com/embed/${videoId}?rel=0`}
          title="Youtube Video"
        ></iframe>
      </div>
    )}
  </>
);

export default Video;
